import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Column, Spacer } from "../../Layout/Layout";
import styles from "./ContactInfo.module.css";
import useTranslations from "../../../core/i18n/useTranslations";
import useBranding from "../../../core/branding/useBranding";
import useUser from "../../../core/user/useUser";
import { notifyApiErrors } from "../../../core/helpers/helpers";
import { getSupportInfo } from "../../../core/api/administrators/administrators";
import LoadingSpinner from "../../../ui-lib/components/Loading/LoadingSpinner";
import { SupportData } from "../../../core/api/administrators/types";

const InfoBlock = ({
  title,
  email,
  phoneNumber,
}: {
  title: string;
  email: string;
  phoneNumber: string;
}) => (
  <>
    <h3 className={styles.light}>{title}</h3>
    <Spacer size={4} />
    <p className={styles.semibold}>
      <a href={`mailto:${email}`}>{email}</a>
    </p>
    <p className={styles.semibold}>
      <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
    </p>
  </>
);

const ContactInfo = () => {
  const t = useTranslations();
  const { authenticatedRequest } = useUser();
  const [isLoading, setIsLoading] = useState(false);
  const [brandInfo, setBrandInfo] = useState<SupportData>();
  const currentBrand = useBranding().customerKey;

  const fetchBrandingSupport = async () => {
    try {
      setIsLoading(true);
      const results = await getSupportInfo(authenticatedRequest, currentBrand);
      setBrandInfo(results.data);
    } catch (error: any) {
      notifyApiErrors(error.response?.data?.errors);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBrandingSupport();
  }, []);

  if (isLoading || !brandInfo) {
    return (
      <div className={styles.container}>
        <LoadingSpinner theme="primary" />
      </div>
    );
  }

  return (
    <div>
      <Column align="start">
        <span>{t("Home:description_contact_info")}</span>
        <Link
          to={{ pathname: "https://status.skyresponse.com" }}
          target="_blank"
        >
          {t("Home:description_contact_link")}
        </Link>
      </Column>
      <Spacer size={16} />
      <InfoBlock
        title={t("Home:technical_support")}
        email={brandInfo.emailTechnicalSupport}
        phoneNumber={brandInfo.phoneTechnicalSupport}
      />
      <Spacer size={16} />
      <InfoBlock
        title={t("Home:administration")}
        email={brandInfo.emailAdministrative}
        phoneNumber={brandInfo.phoneAdministrative}
      />
    </div>
  );
};

export default ContactInfo;
